export default __webpack_public_path__ + "static/media/deluxe-off-grid-package.31c2c950.jpg";